import dateMapper from '../../mappers/DateMapper';

// Common styles
export const WRAP_STYLE = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis"
};

// Date cutoff for displaying dates
export const CUT_OFF_DATE = new Date(2018, 6, 20); // July 20, 2018

/**
 * Format project display date with cutoff logic
 * @param {string} updatedAt - The updated_at date string
 * @returns {string} The formatted date or '...' if before cutoff
 */
export function formatProjectDate(updatedAt) {
  const { date, dateString } = dateMapper(updatedAt);
  return date && date > CUT_OFF_DATE ? dateString : '...';
}

/**
 * Get display name for project
 * @param {string} name - The project name
 * @returns {string} Trimmed name or 'Untitled Project'
 */
export function getProjectDisplayName(name) {
  const trimmedName = (name || '').trim();
  return trimmedName ? trimmedName : "Untitled Project";
}

/**
 * Get owner display text
 * @param {object} owner - The owner object
 * @returns {string} Owner name, email, or '-'
 */
export function getOwnerDisplay(owner) {
  if (!owner) return '-';
  return owner.name || owner.email || '-';
}